import React, { Dispatch } from 'react';
import {
  Grid,
} from '@material-ui/core';
import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { EventCategory } from '../../../store/event/types';
import EventCategoryCheckbox from './EventCategoryCheckbox';
import WhitePaper from '../../../components/paper/WhitePaper';
import { updateFiltersEvent } from '../../../store/event/actions';

type Props = {
  categories: EventCategory[],
  categoryIds: string[]
}

const EventCategories = ({ categories, categoryIds }: Props) => {
  const { t } = useTranslation(['backoffice']);

  const dispatch: Dispatch<any> = useDispatch();

  const handleChange = (categoryId: string) => {
    const categoryIdExist = categoryIds.find((c) => c === categoryId);

    let newList: string[];
    if (categoryIdExist) {
      newList = categoryIds.filter((c) => c !== categoryId);
    } else {
      newList = [...categoryIds, categoryId];
    }

    dispatch(updateFiltersEvent(newList));
  };

  return (
    <Grid item xs={12}>
      <WhitePaper title={t('event.category_title')}>
        {categories.map((category) => (
          <EventCategoryCheckbox
            key={category.id}
            category={category}
            handleChange={handleChange}
            categoryIds={categoryIds}
          />
        ))}
      </WhitePaper>
    </Grid>
  );
};

export default EventCategories;
